import { useTranslation } from 'react-i18next'
import { SectionRowVariant } from '@ui/elements/SectionRow/styles'
import SectionRow from '@ui/elements/SectionRow'
import PressableIcon from '@ui/buttons/PressableIcon'
import type { CofidisSectionConfig } from '../sections'

export type SectionStatus = 'valid' | 'invalid' | 'pending'

const statusToVariant: Record<SectionStatus, SectionRowVariant> = {
  valid: 'success',
  invalid: 'danger',
  pending: 'default',
}

export type SectionListItemProps = {
  section: CofidisSectionConfig
  index: number
  errorsCount: number
  submitted: boolean
  submitAttempted: boolean
  onPress: () => void
}

export const getSectionStatus = (
  submitted: boolean,
  submitAttempted: boolean,
  errorsCount: number
): SectionStatus =>
  submitted || submitAttempted
    ? errorsCount > 0
      ? 'invalid'
      : 'valid'
    : 'pending'

export default function SectionListItem({
  section,
  index,
  errorsCount,
  submitted,
  submitAttempted,
  onPress,
}: SectionListItemProps) {
  const { t } = useTranslation(['cofidis'])
  const text = `cofidis:sections.${section.name}.row`

  const status = getSectionStatus(submitted, submitAttempted, errorsCount)

  const info =
    status === 'valid'
      ? t('status:fieldsValid')
      : status === 'invalid'
      ? t('status:fieldsInvalid', { number: errorsCount })
      : undefined

  return (
    <SectionRow
      key={section.name}
      icon={section.icon}
      variant={statusToVariant[status]}
      title={t(`${text}.title`)}
      desc={status !== 'valid' ? t(`${text}.desc`) : undefined}
      info={info}
      index={index}
      isGrouped
      onPress={onPress}
      actionComponent={<PressableIcon name="chevron-right" />}
    />
  )
}
